import React from 'react'
import { CheckMarkIcon, PayPeriodIcon, Pill } from '@viveaesthetics/shared'

import { InsurancesEnum } from '@/types/providers'

interface InsurancePillProps {
  insurance: InsurancesEnum | string
  cashPayHourlyRate?: number
}

export const InsurancePill = ({
  insurance,
  cashPayHourlyRate
}: InsurancePillProps) => {
  return (
    <Pill
      icon={
        insurance === InsurancesEnum.CASH ? (
          <PayPeriodIcon $color="iconSuccess" />
        ) : (
          <CheckMarkIcon $color="iconSuccess" />
        )
      }
      label={insurance}
      description={
        insurance === InsurancesEnum.CASH
          ? `$${cashPayHourlyRate} per session`
          : ''
      }
      fullWidth
    />
  )
}
